// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/a2ui/v1/a2ui.proto" (package "c1.api.a2ui.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { A2UISurface } from "./surface";
// ═══════════════════════════════════════════════════════════════
// WebSocket Envelope Messages
// ═══════════════════════════════════════════════════════════════

/**
 * A2UIEnvelope wraps all A2UI WebSocket messages.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIEnvelope
 */
export interface A2UIEnvelope {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "surfaceCreated";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.SurfaceCreated surface_created = 1
         */
        surfaceCreated: SurfaceCreated;
    } | {
        oneofKind: "surfaceUpdated";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.SurfaceUpdated surface_updated = 2
         */
        surfaceUpdated: SurfaceUpdated;
    } | {
        oneofKind: "surfaceDeleted";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.SurfaceDeleted surface_deleted = 3
         */
        surfaceDeleted: SurfaceDeleted;
    } | {
        oneofKind: "dataModelUpdated";
        /**
         * @generated from protobuf field: c1.api.a2ui.v1.DataModelUpdated data_model_updated = 4
         */
        dataModelUpdated: DataModelUpdated;
    } | {
        oneofKind: undefined;
    };
}
/**
 * SurfaceCreated is sent when a new surface is created.
 *
 * @generated from protobuf message c1.api.a2ui.v1.SurfaceCreated
 */
export interface SurfaceCreated {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UISurface surface = 1
     */
    surface?: A2UISurface;
}
/**
 * SurfaceUpdated is sent when a surface is updated.
 *
 * @generated from protobuf message c1.api.a2ui.v1.SurfaceUpdated
 */
export interface SurfaceUpdated {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UISurface surface = 1
     */
    surface?: A2UISurface;
}
/**
 * SurfaceDeleted is sent when a surface is deleted.
 *
 * @generated from protobuf message c1.api.a2ui.v1.SurfaceDeleted
 */
export interface SurfaceDeleted {
    /**
     * @generated from protobuf field: string surface_id = 1
     */
    surfaceId: string;
}
/**
 * DataModelUpdated is sent when the data model changes.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DataModelUpdated
 */
export interface DataModelUpdated {
    /**
     * @generated from protobuf field: string surface_id = 1
     */
    surfaceId: string;
    /**
     * @generated from protobuf field: string actor_id = 2
     */
    actorId: string;
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.DataUpdate updates = 3
     */
    updates: DataUpdate[];
}
/**
 * DataUpdate represents a single data model update.
 *
 * @generated from protobuf message c1.api.a2ui.v1.DataUpdate
 */
export interface DataUpdate {
    /**
     * @generated from protobuf field: string path = 1
     */
    path: string; // JSON Pointer path
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string; // JSON-encoded value
    /**
     * @generated from protobuf field: string hlc = 3
     */
    hlc: string; // Hybrid logical clock for ordering
}
// ═══════════════════════════════════════════════════════════════
// API Request/Response Messages
// ═══════════════════════════════════════════════════════════════

/**
 * A2UIServiceSubmitActionRequest submits a user action.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceSubmitActionRequest
 */
export interface A2UIServiceSubmitActionRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * @generated from protobuf field: string surface_id = 2
     */
    surfaceId: string;
    /**
     * @generated from protobuf field: string source_component_id = 3
     */
    sourceComponentId: string;
    /**
     * @generated from protobuf field: string action_name = 4
     */
    actionName: string;
    /**
     * @generated from protobuf field: map<string, string> context = 5
     */
    context: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp client_timestamp = 6
     */
    clientTimestamp?: Timestamp;
    /**
     * @generated from protobuf field: string data_model_json = 7
     */
    dataModelJson: string; // Full data model for sendDataModel pattern
}
/**
 * A2UIServiceSubmitActionResponse returns the result of an action.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceSubmitActionResponse
 */
export interface A2UIServiceSubmitActionResponse {
    /**
     * @generated from protobuf field: bool accepted = 1
     */
    accepted: boolean;
    /**
     * @generated from protobuf field: string error_message = 2
     */
    errorMessage: string;
}
/**
 * A2UIServiceListSurfacesRequest lists surfaces for a conversation.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceListSurfacesRequest
 */
export interface A2UIServiceListSurfacesRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
}
/**
 * A2UIServiceListSurfacesResponse returns active surfaces.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceListSurfacesResponse
 */
export interface A2UIServiceListSurfacesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.A2UISurface surfaces = 1
     */
    surfaces: A2UISurface[];
}
/**
 * A2UISurfaceFeedback represents user feedback for a surface.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UISurfaceFeedback
 */
export interface A2UISurfaceFeedback {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string;
    /**
     * @generated from protobuf field: string surface_id = 3
     */
    surfaceId: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment = 4
     */
    sentiment: A2UISurfaceFeedbackSentiment;
    /**
     * @generated from protobuf field: string text = 5
     */
    text: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 schema_version = 7
     */
    schemaVersion: number;
    /**
     * @generated from protobuf field: string data_model_snapshot = 8
     */
    dataModelSnapshot: string;
    /**
     * @generated from protobuf field: string action_name = 9
     */
    actionName: string;
}
/**
 * A2UIServiceCreateSurfaceFeedbackRequest creates feedback for a surface.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackRequest
 */
export interface A2UIServiceCreateSurfaceFeedbackRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * @generated from protobuf field: string surface_id = 2
     */
    surfaceId: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment = 3
     */
    sentiment: A2UISurfaceFeedbackSentiment;
    /**
     * @generated from protobuf field: string text = 4
     */
    text: string;
}
/**
 * A2UIServiceCreateSurfaceFeedbackResponse returns the created feedback.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackResponse
 */
export interface A2UIServiceCreateSurfaceFeedbackResponse {
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UISurfaceFeedback feedback = 1
     */
    feedback?: A2UISurfaceFeedback;
}
/**
 * A2UIServiceListSurfaceFeedbackRequest lists feedback for a surface.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackRequest
 */
export interface A2UIServiceListSurfaceFeedbackRequest {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * @generated from protobuf field: string surface_id = 2
     */
    surfaceId: string;
}
/**
 * A2UIServiceListSurfaceFeedbackResponse returns feedback for a surface.
 *
 * @generated from protobuf message c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackResponse
 */
export interface A2UIServiceListSurfaceFeedbackResponse {
    /**
     * @generated from protobuf field: repeated c1.api.a2ui.v1.A2UISurfaceFeedback feedback = 1
     */
    feedback: A2UISurfaceFeedback[];
}
// ═══════════════════════════════════════════════════════════════
// Surface Feedback Messages
// ═══════════════════════════════════════════════════════════════

/**
 * Sentiment for surface feedback.
 *
 * @generated from protobuf enum c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment
 */
export enum A2UISurfaceFeedbackSentiment {
    /**
     * @generated from protobuf enum value: A2UI_SURFACE_FEEDBACK_SENTIMENT_UNSPECIFIED = 0;
     */
    A2UI_SURFACE_FEEDBACK_SENTIMENT_UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: A2UI_SURFACE_FEEDBACK_SENTIMENT_POSITIVE = 1;
     */
    A2UI_SURFACE_FEEDBACK_SENTIMENT_POSITIVE = 1,
    /**
     * @generated from protobuf enum value: A2UI_SURFACE_FEEDBACK_SENTIMENT_NEGATIVE = 2;
     */
    A2UI_SURFACE_FEEDBACK_SENTIMENT_NEGATIVE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class A2UIEnvelope$Type extends MessageType<A2UIEnvelope> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIEnvelope", [
            { no: 1, name: "surface_created", kind: "message", oneof: "message", T: () => SurfaceCreated },
            { no: 2, name: "surface_updated", kind: "message", oneof: "message", T: () => SurfaceUpdated },
            { no: 3, name: "surface_deleted", kind: "message", oneof: "message", T: () => SurfaceDeleted },
            { no: 4, name: "data_model_updated", kind: "message", oneof: "message", T: () => DataModelUpdated }
        ]);
    }
    create(value?: PartialMessage<A2UIEnvelope>): A2UIEnvelope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<A2UIEnvelope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIEnvelope): A2UIEnvelope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.SurfaceCreated surface_created */ 1:
                    message.message = {
                        oneofKind: "surfaceCreated",
                        surfaceCreated: SurfaceCreated.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).surfaceCreated)
                    };
                    break;
                case /* c1.api.a2ui.v1.SurfaceUpdated surface_updated */ 2:
                    message.message = {
                        oneofKind: "surfaceUpdated",
                        surfaceUpdated: SurfaceUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).surfaceUpdated)
                    };
                    break;
                case /* c1.api.a2ui.v1.SurfaceDeleted surface_deleted */ 3:
                    message.message = {
                        oneofKind: "surfaceDeleted",
                        surfaceDeleted: SurfaceDeleted.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).surfaceDeleted)
                    };
                    break;
                case /* c1.api.a2ui.v1.DataModelUpdated data_model_updated */ 4:
                    message.message = {
                        oneofKind: "dataModelUpdated",
                        dataModelUpdated: DataModelUpdated.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).dataModelUpdated)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIEnvelope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.SurfaceCreated surface_created = 1; */
        if (message.message.oneofKind === "surfaceCreated")
            SurfaceCreated.internalBinaryWrite(message.message.surfaceCreated, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.SurfaceUpdated surface_updated = 2; */
        if (message.message.oneofKind === "surfaceUpdated")
            SurfaceUpdated.internalBinaryWrite(message.message.surfaceUpdated, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.SurfaceDeleted surface_deleted = 3; */
        if (message.message.oneofKind === "surfaceDeleted")
            SurfaceDeleted.internalBinaryWrite(message.message.surfaceDeleted, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.a2ui.v1.DataModelUpdated data_model_updated = 4; */
        if (message.message.oneofKind === "dataModelUpdated")
            DataModelUpdated.internalBinaryWrite(message.message.dataModelUpdated, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIEnvelope
 */
export const A2UIEnvelope = new A2UIEnvelope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SurfaceCreated$Type extends MessageType<SurfaceCreated> {
    constructor() {
        super("c1.api.a2ui.v1.SurfaceCreated", [
            { no: 1, name: "surface", kind: "message", T: () => A2UISurface }
        ]);
    }
    create(value?: PartialMessage<SurfaceCreated>): SurfaceCreated {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SurfaceCreated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SurfaceCreated): SurfaceCreated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.A2UISurface surface */ 1:
                    message.surface = A2UISurface.internalBinaryRead(reader, reader.uint32(), options, message.surface);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SurfaceCreated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.A2UISurface surface = 1; */
        if (message.surface)
            A2UISurface.internalBinaryWrite(message.surface, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.SurfaceCreated
 */
export const SurfaceCreated = new SurfaceCreated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SurfaceUpdated$Type extends MessageType<SurfaceUpdated> {
    constructor() {
        super("c1.api.a2ui.v1.SurfaceUpdated", [
            { no: 1, name: "surface", kind: "message", T: () => A2UISurface }
        ]);
    }
    create(value?: PartialMessage<SurfaceUpdated>): SurfaceUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SurfaceUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SurfaceUpdated): SurfaceUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.A2UISurface surface */ 1:
                    message.surface = A2UISurface.internalBinaryRead(reader, reader.uint32(), options, message.surface);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SurfaceUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.A2UISurface surface = 1; */
        if (message.surface)
            A2UISurface.internalBinaryWrite(message.surface, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.SurfaceUpdated
 */
export const SurfaceUpdated = new SurfaceUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SurfaceDeleted$Type extends MessageType<SurfaceDeleted> {
    constructor() {
        super("c1.api.a2ui.v1.SurfaceDeleted", [
            { no: 1, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SurfaceDeleted>): SurfaceDeleted {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.surfaceId = "";
        if (value !== undefined)
            reflectionMergePartial<SurfaceDeleted>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SurfaceDeleted): SurfaceDeleted {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string surface_id */ 1:
                    message.surfaceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SurfaceDeleted, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string surface_id = 1; */
        if (message.surfaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.surfaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.SurfaceDeleted
 */
export const SurfaceDeleted = new SurfaceDeleted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataModelUpdated$Type extends MessageType<DataModelUpdated> {
    constructor() {
        super("c1.api.a2ui.v1.DataModelUpdated", [
            { no: 1, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "actor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "updates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataUpdate }
        ]);
    }
    create(value?: PartialMessage<DataModelUpdated>): DataModelUpdated {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.surfaceId = "";
        message.actorId = "";
        message.updates = [];
        if (value !== undefined)
            reflectionMergePartial<DataModelUpdated>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataModelUpdated): DataModelUpdated {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string surface_id */ 1:
                    message.surfaceId = reader.string();
                    break;
                case /* string actor_id */ 2:
                    message.actorId = reader.string();
                    break;
                case /* repeated c1.api.a2ui.v1.DataUpdate updates */ 3:
                    message.updates.push(DataUpdate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataModelUpdated, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string surface_id = 1; */
        if (message.surfaceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.surfaceId);
        /* string actor_id = 2; */
        if (message.actorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.actorId);
        /* repeated c1.api.a2ui.v1.DataUpdate updates = 3; */
        for (let i = 0; i < message.updates.length; i++)
            DataUpdate.internalBinaryWrite(message.updates[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DataModelUpdated
 */
export const DataModelUpdated = new DataModelUpdated$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataUpdate$Type extends MessageType<DataUpdate> {
    constructor() {
        super("c1.api.a2ui.v1.DataUpdate", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "hlc", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DataUpdate>): DataUpdate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.path = "";
        message.value = "";
        message.hlc = "";
        if (value !== undefined)
            reflectionMergePartial<DataUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DataUpdate): DataUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string path */ 1:
                    message.path = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                case /* string hlc */ 3:
                    message.hlc = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DataUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string path = 1; */
        if (message.path !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.path);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        /* string hlc = 3; */
        if (message.hlc !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.hlc);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.DataUpdate
 */
export const DataUpdate = new DataUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceSubmitActionRequest$Type extends MessageType<A2UIServiceSubmitActionRequest> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceSubmitActionRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } },
            { no: 2, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } },
            { no: 3, name: "source_component_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "context", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 6, name: "client_timestamp", kind: "message", T: () => Timestamp },
            { no: 7, name: "data_model_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceSubmitActionRequest>): A2UIServiceSubmitActionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.surfaceId = "";
        message.sourceComponentId = "";
        message.actionName = "";
        message.context = {};
        message.dataModelJson = "";
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceSubmitActionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceSubmitActionRequest): A2UIServiceSubmitActionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string surface_id */ 2:
                    message.surfaceId = reader.string();
                    break;
                case /* string source_component_id */ 3:
                    message.sourceComponentId = reader.string();
                    break;
                case /* string action_name */ 4:
                    message.actionName = reader.string();
                    break;
                case /* map<string, string> context */ 5:
                    this.binaryReadMap5(message.context, reader, options);
                    break;
                case /* google.protobuf.Timestamp client_timestamp */ 6:
                    message.clientTimestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.clientTimestamp);
                    break;
                case /* string data_model_json */ 7:
                    message.dataModelJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: A2UIServiceSubmitActionRequest["context"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof A2UIServiceSubmitActionRequest["context"] | undefined, val: A2UIServiceSubmitActionRequest["context"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.a2ui.v1.A2UIServiceSubmitActionRequest.context");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: A2UIServiceSubmitActionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string surface_id = 2; */
        if (message.surfaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.surfaceId);
        /* string source_component_id = 3; */
        if (message.sourceComponentId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sourceComponentId);
        /* string action_name = 4; */
        if (message.actionName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.actionName);
        /* map<string, string> context = 5; */
        for (let k of globalThis.Object.keys(message.context))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.context[k]).join();
        /* google.protobuf.Timestamp client_timestamp = 6; */
        if (message.clientTimestamp)
            Timestamp.internalBinaryWrite(message.clientTimestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string data_model_json = 7; */
        if (message.dataModelJson !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dataModelJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceSubmitActionRequest
 */
export const A2UIServiceSubmitActionRequest = new A2UIServiceSubmitActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceSubmitActionResponse$Type extends MessageType<A2UIServiceSubmitActionResponse> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceSubmitActionResponse", [
            { no: 1, name: "accepted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceSubmitActionResponse>): A2UIServiceSubmitActionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accepted = false;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceSubmitActionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceSubmitActionResponse): A2UIServiceSubmitActionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool accepted */ 1:
                    message.accepted = reader.bool();
                    break;
                case /* string error_message */ 2:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceSubmitActionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool accepted = 1; */
        if (message.accepted !== false)
            writer.tag(1, WireType.Varint).bool(message.accepted);
        /* string error_message = 2; */
        if (message.errorMessage !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceSubmitActionResponse
 */
export const A2UIServiceSubmitActionResponse = new A2UIServiceSubmitActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceListSurfacesRequest$Type extends MessageType<A2UIServiceListSurfacesRequest> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceListSurfacesRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceListSurfacesRequest>): A2UIServiceListSurfacesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceListSurfacesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceListSurfacesRequest): A2UIServiceListSurfacesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceListSurfacesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceListSurfacesRequest
 */
export const A2UIServiceListSurfacesRequest = new A2UIServiceListSurfacesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceListSurfacesResponse$Type extends MessageType<A2UIServiceListSurfacesResponse> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceListSurfacesResponse", [
            { no: 1, name: "surfaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => A2UISurface }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceListSurfacesResponse>): A2UIServiceListSurfacesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.surfaces = [];
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceListSurfacesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceListSurfacesResponse): A2UIServiceListSurfacesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.a2ui.v1.A2UISurface surfaces */ 1:
                    message.surfaces.push(A2UISurface.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceListSurfacesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.a2ui.v1.A2UISurface surfaces = 1; */
        for (let i = 0; i < message.surfaces.length; i++)
            A2UISurface.internalBinaryWrite(message.surfaces[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceListSurfacesResponse
 */
export const A2UIServiceListSurfacesResponse = new A2UIServiceListSurfacesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UISurfaceFeedback$Type extends MessageType<A2UISurfaceFeedback> {
    constructor() {
        super("c1.api.a2ui.v1.A2UISurfaceFeedback", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sentiment", kind: "enum", T: () => ["c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment", A2UISurfaceFeedbackSentiment] },
            { no: 5, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "schema_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 8, name: "data_model_snapshot", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "action_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<A2UISurfaceFeedback>): A2UISurfaceFeedback {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.conversationId = "";
        message.surfaceId = "";
        message.sentiment = 0;
        message.text = "";
        message.schemaVersion = 0;
        message.dataModelSnapshot = "";
        message.actionName = "";
        if (value !== undefined)
            reflectionMergePartial<A2UISurfaceFeedback>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UISurfaceFeedback): A2UISurfaceFeedback {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                case /* string surface_id */ 3:
                    message.surfaceId = reader.string();
                    break;
                case /* c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment */ 4:
                    message.sentiment = reader.int32();
                    break;
                case /* string text */ 5:
                    message.text = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* int64 schema_version */ 7:
                    message.schemaVersion = reader.int64().toNumber();
                    break;
                case /* string data_model_snapshot */ 8:
                    message.dataModelSnapshot = reader.string();
                    break;
                case /* string action_name */ 9:
                    message.actionName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UISurfaceFeedback, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        /* string surface_id = 3; */
        if (message.surfaceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.surfaceId);
        /* c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment = 4; */
        if (message.sentiment !== 0)
            writer.tag(4, WireType.Varint).int32(message.sentiment);
        /* string text = 5; */
        if (message.text !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.text);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int64 schema_version = 7; */
        if (message.schemaVersion !== 0)
            writer.tag(7, WireType.Varint).int64(message.schemaVersion);
        /* string data_model_snapshot = 8; */
        if (message.dataModelSnapshot !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dataModelSnapshot);
        /* string action_name = 9; */
        if (message.actionName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.actionName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UISurfaceFeedback
 */
export const A2UISurfaceFeedback = new A2UISurfaceFeedback$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceCreateSurfaceFeedbackRequest$Type extends MessageType<A2UIServiceCreateSurfaceFeedbackRequest> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } },
            { no: 2, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } },
            { no: 3, name: "sentiment", kind: "enum", T: () => ["c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment", A2UISurfaceFeedbackSentiment], options: { "validate.rules": { enum: { notIn: [0] } } } },
            { no: 4, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceCreateSurfaceFeedbackRequest>): A2UIServiceCreateSurfaceFeedbackRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.surfaceId = "";
        message.sentiment = 0;
        message.text = "";
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceCreateSurfaceFeedbackRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceCreateSurfaceFeedbackRequest): A2UIServiceCreateSurfaceFeedbackRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string surface_id */ 2:
                    message.surfaceId = reader.string();
                    break;
                case /* c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment */ 3:
                    message.sentiment = reader.int32();
                    break;
                case /* string text */ 4:
                    message.text = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceCreateSurfaceFeedbackRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string surface_id = 2; */
        if (message.surfaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.surfaceId);
        /* c1.api.a2ui.v1.A2UISurfaceFeedbackSentiment sentiment = 3; */
        if (message.sentiment !== 0)
            writer.tag(3, WireType.Varint).int32(message.sentiment);
        /* string text = 4; */
        if (message.text !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.text);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackRequest
 */
export const A2UIServiceCreateSurfaceFeedbackRequest = new A2UIServiceCreateSurfaceFeedbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceCreateSurfaceFeedbackResponse$Type extends MessageType<A2UIServiceCreateSurfaceFeedbackResponse> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackResponse", [
            { no: 1, name: "feedback", kind: "message", T: () => A2UISurfaceFeedback }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceCreateSurfaceFeedbackResponse>): A2UIServiceCreateSurfaceFeedbackResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceCreateSurfaceFeedbackResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceCreateSurfaceFeedbackResponse): A2UIServiceCreateSurfaceFeedbackResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.a2ui.v1.A2UISurfaceFeedback feedback */ 1:
                    message.feedback = A2UISurfaceFeedback.internalBinaryRead(reader, reader.uint32(), options, message.feedback);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceCreateSurfaceFeedbackResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.a2ui.v1.A2UISurfaceFeedback feedback = 1; */
        if (message.feedback)
            A2UISurfaceFeedback.internalBinaryWrite(message.feedback, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceCreateSurfaceFeedbackResponse
 */
export const A2UIServiceCreateSurfaceFeedbackResponse = new A2UIServiceCreateSurfaceFeedbackResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceListSurfaceFeedbackRequest$Type extends MessageType<A2UIServiceListSurfaceFeedbackRequest> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackRequest", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } },
            { no: 2, name: "surface_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceListSurfaceFeedbackRequest>): A2UIServiceListSurfaceFeedbackRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.surfaceId = "";
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceListSurfaceFeedbackRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceListSurfaceFeedbackRequest): A2UIServiceListSurfaceFeedbackRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* string surface_id */ 2:
                    message.surfaceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceListSurfaceFeedbackRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* string surface_id = 2; */
        if (message.surfaceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.surfaceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackRequest
 */
export const A2UIServiceListSurfaceFeedbackRequest = new A2UIServiceListSurfaceFeedbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UIServiceListSurfaceFeedbackResponse$Type extends MessageType<A2UIServiceListSurfaceFeedbackResponse> {
    constructor() {
        super("c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackResponse", [
            { no: 1, name: "feedback", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => A2UISurfaceFeedback }
        ]);
    }
    create(value?: PartialMessage<A2UIServiceListSurfaceFeedbackResponse>): A2UIServiceListSurfaceFeedbackResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.feedback = [];
        if (value !== undefined)
            reflectionMergePartial<A2UIServiceListSurfaceFeedbackResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UIServiceListSurfaceFeedbackResponse): A2UIServiceListSurfaceFeedbackResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.a2ui.v1.A2UISurfaceFeedback feedback */ 1:
                    message.feedback.push(A2UISurfaceFeedback.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UIServiceListSurfaceFeedbackResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.a2ui.v1.A2UISurfaceFeedback feedback = 1; */
        for (let i = 0; i < message.feedback.length; i++)
            A2UISurfaceFeedback.internalBinaryWrite(message.feedback[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.a2ui.v1.A2UIServiceListSurfaceFeedbackResponse
 */
export const A2UIServiceListSurfaceFeedbackResponse = new A2UIServiceListSurfaceFeedbackResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.a2ui.v1.A2UIService
 */
export const A2UIService = new ServiceType("c1.api.a2ui.v1.A2UIService", [
    { name: "SubmitAction", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/a2ui/surfaces/{surface_id}/actions" }] }, "authz.method": { role: "EDITOR" } }, I: A2UIServiceSubmitActionRequest, O: A2UIServiceSubmitActionResponse },
    { name: "ListSurfaces", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/a2ui/conversations/{conversation_id}/surfaces" }] }, "authz.method": { role: "VIEWER" } }, I: A2UIServiceListSurfacesRequest, O: A2UIServiceListSurfacesResponse },
    { name: "CreateSurfaceFeedback", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/a2ui/surfaces/{surface_id}/feedback" }] }, "authz.method": { role: "EDITOR" } }, I: A2UIServiceCreateSurfaceFeedbackRequest, O: A2UIServiceCreateSurfaceFeedbackResponse },
    { name: "ListSurfaceFeedback", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/a2ui/surfaces/{surface_id}/feedback" }] }, "authz.method": { role: "VIEWER" } }, I: A2UIServiceListSurfaceFeedbackRequest, O: A2UIServiceListSurfaceFeedbackResponse }
]);
